// Field schemas per entity - grouped into tabs (basic / content / seo)
export const SCHEMAS = {
  colleges: {
    title: 'Colleges',
    listFields: ['ranking', 'short', 'city', 'type', 'rating'],
    tabs: [
      { key: 'basic', label: 'Basic', fields: [
        { key: 'name', label: 'Full Name', type: 'text', required: true },
        { key: 'short', label: 'Short Name', type: 'text' },
        { key: 'slug', label: 'URL Slug', type: 'slug' },
        { key: 'location', label: 'Location', type: 'text' },
        { key: 'city', label: 'City', type: 'text' },
        { key: 'state', label: 'State', type: 'text' },
        { key: 'established', label: 'Established', type: 'number' },
        { key: 'type', label: 'Type', type: 'select', options: ['Public', 'Private (Deemed)', 'Autonomous', 'Central University', 'State'] },
        { key: 'accreditation', label: 'Accreditation', type: 'text' },
        { key: 'ranking', label: 'Ranking', type: 'number' },
        { key: 'rating', label: 'Rating', type: 'number', step: 0.1 },
        { key: 'reviews', label: 'Reviews', type: 'number' },
        { key: 'fees', label: 'Fees (display)', type: 'text' },
        { key: 'image', label: 'Cover Image URL', type: 'image' },
        { key: 'logo', label: 'Logo URL', type: 'image' },
        { key: 'streams', label: 'Streams (comma sep)', type: 'csv' },
        { key: 'courses', label: 'Courses (comma sep)', type: 'csv' },
        { key: 'author_id', label: 'Author / Editor', type: 'author' },
      ]},
      { key: 'content', label: 'Content', fields: [
        { key: 'about', label: 'About (short summary)', type: 'textarea' },
        { key: 'highlights', label: 'Highlights (one per line)', type: 'lines' },
        { key: 'content', label: 'Detailed content', type: 'rich' },
      ]},
      { key: 'seo', label: 'SEO', fields: [
        { key: 'meta_title', label: 'Meta Title', type: 'text' },
        { key: 'meta_description', label: 'Meta Description', type: 'textarea' },
        { key: 'meta_keywords', label: 'Meta Keywords (comma sep)', type: 'text' },
        { key: 'og_image', label: 'OG Image URL', type: 'image' },
        { key: 'canonical_url', label: 'Canonical URL', type: 'text' },
      ]},
    ],
  },
  universities: {
    title: 'Universities',
    listFields: ['name', 'location', 'type', 'naac', 'rating'],
    tabs: [
      { key: 'basic', label: 'Basic', fields: [
        { key: 'name', label: 'Name', type: 'text', required: true },
        { key: 'slug', label: 'URL Slug', type: 'slug' },
        { key: 'location', label: 'Location', type: 'text' },
        { key: 'type', label: 'Type', type: 'select', options: ['State', 'Central', 'Private', 'Deemed'] },
        { key: 'naac', label: 'NAAC Grade', type: 'text' },
        { key: 'established', label: 'Established', type: 'number' },
        { key: 'image', label: 'Cover Image', type: 'image' },
        { key: 'courses', label: 'Courses Count', type: 'number' },
        { key: 'rating', label: 'Rating', type: 'number', step: 0.1 },
        { key: 'author_id', label: 'Author / Editor', type: 'author' },
      ]},
      { key: 'content', label: 'Content', fields: [
        { key: 'content', label: 'Detailed content', type: 'rich' },
      ]},
      { key: 'seo', label: 'SEO', fields: [
        { key: 'meta_title', label: 'Meta Title', type: 'text' },
        { key: 'meta_description', label: 'Meta Description', type: 'textarea' },
        { key: 'meta_keywords', label: 'Meta Keywords', type: 'text' },
        { key: 'og_image', label: 'OG Image URL', type: 'image' },
        { key: 'canonical_url', label: 'Canonical URL', type: 'text' },
      ]},
    ],
  },
  courses: {
    title: 'Courses',
    listFields: ['name', 'stream', 'duration', 'colleges'],
    tabs: [
      { key: 'basic', label: 'Basic', fields: [
        { key: 'name', label: 'Name', type: 'text', required: true },
        { key: 'full', label: 'Full Name', type: 'text' },
        { key: 'slug', label: 'URL Slug', type: 'slug' },
        { key: 'duration', label: 'Duration', type: 'text' },
        { key: 'stream', label: 'Stream', type: 'select', options: ['engineering', 'management', 'medical', 'law', 'design', 'arts', 'science', 'commerce'] },
        { key: 'avgFees', label: 'Avg Fees', type: 'text' },
        { key: 'avgSalary', label: 'Avg Salary', type: 'text' },
        { key: 'colleges', label: 'Colleges Count', type: 'number' },
        { key: 'author_id', label: 'Author / Editor', type: 'author' },
      ]},
      { key: 'content', label: 'Content', fields: [
        { key: 'description', label: 'Short description', type: 'textarea' },
        { key: 'content', label: 'Detailed content', type: 'rich' },
      ]},
      { key: 'seo', label: 'SEO', fields: [
        { key: 'meta_title', label: 'Meta Title', type: 'text' },
        { key: 'meta_description', label: 'Meta Description', type: 'textarea' },
        { key: 'meta_keywords', label: 'Meta Keywords', type: 'text' },
        { key: 'og_image', label: 'OG Image URL', type: 'image' },
        { key: 'canonical_url', label: 'Canonical URL', type: 'text' },
      ]},
    ],
  },
  exams: {
    title: 'Exams',
    listFields: ['name', 'stream', 'level', 'mode', 'nextDate'],
    tabs: [
      { key: 'basic', label: 'Basic', fields: [
        { key: 'name', label: 'Name', type: 'text', required: true },
        { key: 'full', label: 'Full Name', type: 'text' },
        { key: 'slug', label: 'URL Slug', type: 'slug' },
        { key: 'stream', label: 'Stream', type: 'select', options: ['engineering', 'management', 'medical', 'law', 'design', 'arts', 'science', 'commerce'] },
        { key: 'level', label: 'Level', type: 'select', options: ['National', 'State', 'University'] },
        { key: 'mode', label: 'Mode', type: 'select', options: ['Online', 'Offline', 'Pen-Paper', 'Hybrid'] },
        { key: 'frequency', label: 'Frequency', type: 'text' },
        { key: 'nextDate', label: 'Next Date', type: 'text' },
        { key: 'registrations', label: 'Registrations', type: 'text' },
        { key: 'image', label: 'Cover Image', type: 'image' },
        { key: 'author_id', label: 'Author / Editor', type: 'author' },
      ]},
      { key: 'content', label: 'Content', fields: [
        { key: 'description', label: 'Short description', type: 'textarea' },
        { key: 'content', label: 'Detailed content', type: 'rich' },
      ]},
      { key: 'seo', label: 'SEO', fields: [
        { key: 'meta_title', label: 'Meta Title', type: 'text' },
        { key: 'meta_description', label: 'Meta Description', type: 'textarea' },
        { key: 'meta_keywords', label: 'Meta Keywords', type: 'text' },
        { key: 'og_image', label: 'OG Image URL', type: 'image' },
        { key: 'canonical_url', label: 'Canonical URL', type: 'text' },
      ]},
    ],
  },
  blogs: {
    title: 'Blogs',
    listFields: ['title', 'category', 'author', 'date'],
    tabs: [
      { key: 'basic', label: 'Basic', fields: [
        { key: 'title', label: 'Title', type: 'text', required: true },
        { key: 'slug', label: 'URL Slug', type: 'slug' },
        { key: 'excerpt', label: 'Excerpt', type: 'textarea' },
        { key: 'author_id', label: 'Author', type: 'author' },
        { key: 'author', label: 'Author (display name)', type: 'text' },
        { key: 'date', label: 'Date', type: 'text' },
        { key: 'category', label: 'Category', type: 'select', options: ['Exam Prep', 'College Guide', 'News', 'Career', 'Scholarships', 'Guide'] },
        { key: 'readTime', label: 'Read Time', type: 'text' },
        { key: 'image', label: 'Cover Image', type: 'image' },
      ]},
      { key: 'content', label: 'Content', fields: [
        { key: 'content', label: 'Article content', type: 'rich' },
      ]},
      { key: 'seo', label: 'SEO', fields: [
        { key: 'meta_title', label: 'Meta Title', type: 'text' },
        { key: 'meta_description', label: 'Meta Description', type: 'textarea' },
        { key: 'meta_keywords', label: 'Meta Keywords', type: 'text' },
        { key: 'og_image', label: 'OG Image URL', type: 'image' },
        { key: 'canonical_url', label: 'Canonical URL', type: 'text' },
      ]},
    ],
  },
  authors: {
    title: 'Authors',
    listFields: ['name', 'designation', 'email', 'is_fact_checker'],
    tabs: [
      { key: 'basic', label: 'Basic', fields: [
        { key: 'name', label: 'Name', type: 'text', required: true },
        { key: 'slug', label: 'URL Slug', type: 'slug' },
        { key: 'email', label: 'Email', type: 'text' },
        { key: 'designation', label: 'Designation', type: 'text' },
        { key: 'avatar', label: 'Avatar', type: 'image' },
        { key: 'is_fact_checker', label: 'Is Fact Checker', type: 'boolean' },
      ]},
      { key: 'content', label: 'Bio & Socials', fields: [
        { key: 'bio', label: 'Bio', type: 'rich' },
        { key: 'twitter', label: 'Twitter handle', type: 'text' },
        { key: 'linkedin', label: 'LinkedIn username', type: 'text' },
        { key: 'website', label: 'Website', type: 'text' },
      ]},
      { key: 'seo', label: 'SEO', fields: [
        { key: 'meta_title', label: 'Meta Title', type: 'text' },
        { key: 'meta_description', label: 'Meta Description', type: 'textarea' },
      ]},
    ],
  },
};
